module.exports = __webpack_public_path__ + "img/music.4c717e80.png";